import _ from 'lodash';

import type { CompRef } from 'types/documentServices';
import type { HistoryAddOptions, HistoryApi } from '../createHistoryApi';
import type { EditorAPI } from '#packages/editorAPI';

export function createLayoutResizeApi_structure({
  editorAPI,
  historyApi,
}: {
  editorAPI: EditorAPI;
  historyApi: HistoryApi;
}) {
  function resizeToAndPushTransition(compRef: CompRef) {
    editorAPI.components.layout.setLayoutReadFromDOM(true);
    // eslint-disable-next-line @wix/santa-editor/deprecatedDSApi
    editorAPI.components.layout.updateAndPushStart(compRef);

    const update = (yOrHeight: { y?: number; height?: number }) => {
      if (!_.isNumber(yOrHeight.height)) {
        if (_.isNumber(yOrHeight.y)) {
          throw new Error('resizeToAndPush with `y` is not supported yet');
        }

        throw new Error('resizeToAndPush `height` must be a number');
      }

      editorAPI.components.layout.resizeAndPush(compRef, {
        height: yOrHeight.height,
      });
    };

    const end = async (options: HistoryAddOptions & {} = {}) => {
      // eslint-disable-next-line @wix/santa-editor/deprecatedDSApi
      editorAPI.components.layout.updateAndPushEnd(compRef);
      editorAPI.components.layout.setLayoutReadFromDOM(false);
      historyApi.add('component - move and push', options);
    };

    return {
      update,
      end,
    };
  }

  return {
    resizeToAndPushTransition,
  };
}

export type LayoutResizeApiByStructure = ReturnType<
  typeof createLayoutResizeApi_structure
>;
